import React, { useEffect, useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import {
  NuDate,
  NuInput,
  NuMobileNumber,
  NuTextArea,
  NuUpload,
} from "../../../../Components/Utils/Input";
import FormikSelectTwo, {
  FormikSelectWithAdd,
  SelectProductWithError,
} from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import * as yup from "yup";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import axiosInstance from "../../../../Services/axiosCommon";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import DeleteIcon from "../../../../Components/Icons/Delete";
import UseEqupiProductDropDownNew from "../../../../Components/Hooks/useEqupiProductDropDown";
import EditIcon from "../../../../Components/Icons/Edit";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { addMonths, addYears, addWeeks, addDays } from "date-fns";
import UseDropDownNew from "../../../../Components/Hooks/useDropDownNew";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";

function CreateContractsTest() {
  const toast = useToast();
  const [minRenewalDate, setMinRenewalDate] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupEquipment, setShowPopupEquipment] = useState(false);
  const [isInspectionEditable, setIsInspectionEditable] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const { Oncancel, addFormData, isLoading } = useAddFormData();
  const [Equipitems, setEquipItems] = useState([]);
  const [rows] = useState([]);
  const [items, setItems] = useState([]);
  const [, setError] = useState("");
  const [searchClient, setSearchClient] = useState("");
  const [searchequipment, setSearchequipment] = useState("");
  const [inspectionProductError, setInspectionProductError] = useState("");
  const [inspectionError, setInspectionError] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [Newcontract, setContract] = useState([]);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [removableItem, SetRemovableItem] = useState("Undefined");
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [image, setImage] = useState([]);
  const [createNew] = useState({
    amount: "",
    attachments: [],
    clientId: "",
    description: "",
    duration: "",
    endDate: "",
    formSelection: [],
    inspectionType: "",
    renewalDate: "",
    srId: null,
    startDate: "",
    status: "",
    equipments: [],
    schedules: [],
    buildingName: "",
    notes: "",
    paymentTerms: "",
    noticePeriod: "",
  });

  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );

  const { data: Item, setData } = UseEqupiProductDropDownNew(
    "/equipments/drop-down",
    searchequipment
  );

  const { value: location, getData: reflocation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Inspection_Location"
  );

  const { value: industry, getData: refindustry } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "industry"
  );

  const { value: Rating, getData: refRating } = useFetchMetaStar(
    `/dropdown/dropdown-details/`,
    "ratings"
  );

  const { value: designation, getData: refdesignation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Designation_Client"
  );

  const { data: form } = UseDropDownNew(`/form/drop-down`);

  const { value: paymentTerms, getData: refpaymentTerms } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "paymentTerms"
  );

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);

    setImage(fileArr);
    e.target.value = null;
  }

  const [equipmentOptions, setEquipmentOptions] = useState([]);

const getEquipments = async () => {
  try {
    const res = await axiosInstance.get(`/equipments/drop-down`);
    if (Array.isArray(res?.data)) {
      const formatted = res?.data.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setEquipmentOptions(formatted);
    }
  } catch (err) {
    console.error("Error fetching equipments:", err);
    setEquipmentOptions([]);
  }
};

useEffect(() => {
  getEquipments();
}, []);


  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  const deleteFormFromItem = (itemIndex, formIndex) => {
    // Create a copy of the items array to avoid direct state mutation
    const updatedItems = [...items];

    // Access the specific item
    const targetItem = updatedItems[itemIndex];

    // Create a copy of the formSelection array for that item and remove the form
    targetItem.formSelection = targetItem?.formSelection.filter(
      (_, idx) => idx !== formIndex
    );

    // Update the state with the new array
    setItems(updatedItems);
  };

  const validationSchema = yup.object({
    duration: yup.string().required("Duration is required!"),
    clientId: yup.string().required("Client is required!"),
    startDate: yup.date().required("Start date is required"),
    endDate: yup
      .date()
      .required("End date is required")
      .min(yup.ref("startDate"), "End date must be after start date"),
    inspectionDates: yup.array().of(
      yup.object().shape({
        date: yup
          .date()
          .required("Date is required")
          .test(
            "within-range",
            "Date must be between contract start and end",
            function (value) {
              const { startDate, endDate } = this.options.context;
              if (!value || !startDate || !endDate) return false;
              const dateVal = new Date(value);
              return (
                dateVal >= new Date(startDate) && dateVal <= new Date(endDate)
              );
            }
          ),
      })
    ),
  });

  const formik = useFormik({
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
    context: {
      startDate: createNew.startDate,
      endDate: createNew.endDate,
    },
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        equipments: Equipitems,
        schedules: rows,
        inspectionDetails: items,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      await addFormData({
        url: `/contract/new-contract`,
        formData: formData,
        navigateUrl: `/Contract-management/contracts`,
        resetForm: resetForm,
      });
    },
  });

  const [addInspection, setAddInspection] = useState({
    equipmentId: "",
    location: "",
    inspectionType: "",
    formSelection: "",
  });

  const formikAddInspection = useFormik({
    initialValues: addInspection,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: "",
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      if (Equipitems) {
        let finalData = [];
        Equipitems.forEach((item, index) => {
          console.log("Item", item);
          let tempData = {
            equipmentId: item?.equipmentId || "",
            Name: item?.productName || "",
            Unit: item?.unit || "",
            Quantity: item?.quantity || "",
          };
          finalData.push(tempData);
        });
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const wb = XLSX.utils.book_new();

        const ws = XLSX.utils.aoa_to_sheet([
          Object.keys(finalData[0]),
          ...finalData.map((obj) => Object.values(obj)),
        ]);

        const headers = Object.keys(finalData[0]);
        headers.forEach((header, index) => {
          const headerCellRef = XLSX.utils.encode_cell({ r: 4, c: index });
          if (!ws[headerCellRef]) return;
          ws[headerCellRef].s = { font: { bold: true } };
        });

        ws["!cols"] = [
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
        ];
        XLSX.utils.book_append_sheet(wb, ws, "Data");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(
          data,
          `Equiment Export ${new Date().toISOString()} ` + fileExtension
        );
      }
    },
  });

  const closeModal = () => {
    setShowImportModal(false);
  };

  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const readExcel = (file) => {
    if (!file) {
      setError("Please select a file to import.");
      return;
    }

    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, { type: "buffer" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        console.log("DATA -- IMPORT", data);

        const mappedData = data.map((item) => ({
          equipmentId: item.equipmentId || "",
          productName: item.Name || "",
          quantity: item.Quantity || 0,
          unit: item.Unit || "",
        }));

        resolve(mappedData);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise
      .then((mappedData) => {
        setEquipItems([...Equipitems, ...mappedData]);
        setShowImportModal(false);
        setError("");
      })
      .catch((err) => {
        setError(
          "Failed to read the file. Please ensure it's a valid Excel file."
        );
        console.error(err);
      });
  };

  const [showExport, setShowExport] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const togglePopupEqupiment = () => {
    setShowPopupEquipment(!showPopupEquipment);
  };

  function getView(clientId) {
    axiosInstance
      .get(`/survey-report/drop-down/client/${clientId}`)
      .then((res) => {
        const formattedContracts =
          res.data?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || [];
        setContract(formattedContracts);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const [activity, setActivity] = useState();
  function getViewItem() {
    axiosInstance
      .get(`/equipments/drop-down`)
      .then((res) => {
        const formattedActivity =
          res.data?.map((item) => ({
            value: item.id,
            label: item.name,
            refNumber: item.refNumber,
            unit: item.unit || "-",
          })) || [];

        setActivity(formattedActivity);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }
  useEffect(() => {
    getViewItem();
  }, []);

  const calculateEndDateFromDays = (startDate, duration) => {
    if (!startDate || !duration) return "";

    const date = new Date(startDate);
    const parts = duration.split(" ");
    const value = parseInt(parts[0]);
    const unit = parts[1]?.toLowerCase() || "";

    if (unit.includes("month")) {
      const endDate = addMonths(date, value);
      endDate.setDate(endDate.getDate() - 1);
      return endDate.toISOString().split("T")[0];
    } else if (unit.includes("year")) {
      const endDate = addYears(date, value);
      endDate.setDate(endDate.getDate() - 1);
      return endDate.toISOString().split("T")[0];
    } else if (unit.includes("week")) {
      const endDate = addWeeks(date, value);
      return endDate.toISOString().split("T")[0];
    } else if (unit.includes("day")) {
      const endDate = addDays(date, value - 1);
      return endDate.toISOString().split("T")[0];
    }

    return "";
  };

  const handleAddInspection = () => {
    let hasError = false;

    if (!formikAddInspection.values.equipmentId) {
      setInspectionProductError("Required");
      hasError = true;
    } else {
      setInspectionProductError("");
    }

    if (hasError) return;

    if (formikAddInspection.values.equipmentId) {
      const selectedEquipment = activity.find(
        (item) => item.value === formikAddInspection.values.equipmentId
      );

      const newItem = {
        equipmentId: formikAddInspection.values.equipmentId,
        productName: selectedEquipment
          ? selectedEquipment.label
          : "Unknown Item",
        location: formikAddInspection.values.location || "",
        inspectionType: formikAddInspection.values.inspectionType || "",
        formSelection: formikAddInspection.values.formSelection || [],
      };

      const isDuplicate = items.some(
        (it) =>
          it.equipmentId === newItem.equipmentId &&
          it.location === newItem.location &&
          it.inspectionType === newItem.inspectionType &&
          JSON.stringify(it.formSelection) ===
            JSON.stringify(newItem.formSelection)
      );

      if (isDuplicate) {
        toast.open({
          type: "warning",
          description: "This item already exists.",
          message: `Duplicate item`,
        });
        return;
      }

      setItems([...items, newItem]);

      let updatedItems = Item.filter(
        (it) => it.value !== formikAddInspection.values.equipmentId
      );
      setData(updatedItems);

      formikAddInspection.resetForm({
        values: {
          equipmentId: "",
          unit: "",
          location: "",
          inspectionType: "",
          formSelection: [],
        },
      });

      setAddInspection({
        equipmentId: "",
        unit: "",
        location: "",
        inspectionType: "",
        formSelection: [],
      });

      setInspectionError("");
    }
  };

  const handleDeleteItem = (indexToDelete, section) => {
    if (section === "inspection") {
      const deletedItem = items[indexToDelete];
      const updatedItems = items.filter((_, index) => index !== indexToDelete);
      setItems(updatedItems);
      if (deletedItem) {
        setData([
          ...Item,
          { value: deletedItem.equipmentId, label: deletedItem.productName },
        ]);
      }
    } else {
      const deletedItem = Equipitems[indexToDelete];
      const updatedItems = Equipitems.filter(
        (_, index) => index !== indexToDelete
      );
      setEquipItems(updatedItems);
      if (deletedItem) {
        setData([
          ...Item,
          { value: deletedItem.equipmentId, label: deletedItem.productName },
        ]);
      }
    }
  };

  const resetForm = () => {
    formik.setValues({
      ...formik.values,
      companyName: "",
      email: "",
      industry: "",
      pcName: "",
      pcDesignation: "",
      pcCountryCode: "",
      pcMobile: "",
      phoneCC: "",
      phone: "",
      ratings: "",
    });
    setShowPopup(false);
  };

  const handlePopupSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append(
      "json_data",
      JSON.stringify({
        companyName: formik.values.companyName || "",
        email: formik.values.email || "",
        industry: formik.values.industry || "",
        category: formik.values.category || "",
        pcName: formik.values.pcName || "",
        pcDesignation: formik.values.pcDesignation || "",
        pcCountryCode: formik.values.pcCountryCode || "",
        pcMobile: formik.values.pcMobile || "",
        phone: formik.values.phone || "",
        phoneCC: formik.values.phoneCC || "",
        ratings: formik.values.ratings || "",
      })
    );
    try {
      const response = await axiosInstance.post(
        "/clients/new-client",
        formData
      );
      const createdAgent = response.data?.data;
      setDataCustomer((prevCustomers) => [
        {
          label: formik.values.companyName || "-",
          value: createdAgent,
        },
        ...prevCustomers,
      ]);
      resetForm();
    } catch (error) {
      console.error("Error creating new customer:", error);
    }
  };

  const handlePopupSubmitEquipmt = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "json_data",
      JSON.stringify({
        name: formik.values.name || "",
        brand: formik.values.brand || "",
        unit: formik.values.unit || "",
        model: formik.values.model || "",
      })
    );
    try {
      const response = await axiosInstance.post(
        "/equipments/new-equipment",
        formData
      );
      const createdEquipt = response.data?.data;

      setData((prevEquipments) => [
        {
          label: formik.values.name || "-",
          value: createdEquipt,
        },
        ...prevEquipments,
      ]);

      formik.setFieldValue("name", "");
      formik.setFieldValue("brand", "");
      formik.setFieldValue("unit", "");
      formik.setFieldValue("model", "");
      togglePopupEqupiment();
    } catch (error) {
      console.error("Error creating new equipment:", error);
    }
  };

  useEffect(() => {
    if (formik.values.clientId) {
      getView(formik.values.clientId);
    } else {
      setContract([]);
    }
  }, [formik.values.clientId]);

  useEffect(() => {
    const { duration, startDate } = formik.values;
    if (duration && startDate) {
      const calculatedEndDate = calculateEndDateFromDays(startDate, duration);
      formik.setFieldValue("endDate", calculatedEndDate);
      setMinRenewalDate(calculatedEndDate);
    }
  }, [formik.values.duration, formik.values.startDate]);

  useEffect(() => {
    const { endDate } = formik.values;
    if (endDate) {
      const endDateObj = new Date(endDate);
      endDateObj.setDate(endDateObj.getDate() + 1);
      const renewalDate = endDateObj.toISOString().split("T")[0];
      formik.setFieldValue("renewalDate", renewalDate);
    }
  }, [formik.values.endDate]);

  return (
    <div className="w-full h-full py-2 px-4">
      <div className="flex justify-between w-full">
        <Breadcrumb
          items={[
            {
              name: "Contracts",
              link: "/Contract-management/contracts",
            },
            { name: "Create" },
          ]}
        />
        <BackButton />
      </div>
      <div className="w-full mx-auto h-[calc(100vh-151px)] overflow-y-auto mt-4">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full h-full flex justify-start rounded-md bg-white content-start flex-wrap py-2 px-4 overflow-y-auto">
            <div className="w-full">
              <SettingHeading title="Contracts :" />
            </div>

            <FormikSelectWithAdd
              label="Client "
              placeholder="Client  "
              Options={client}
              formik={formik}
              name="clientId"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
              handleClick={togglePopup}
              setSearch={setSearchClient}
              FixPosition={true}
              PortalTarget={false}
            />

            <NuInput
              type="text"
              label="Description"
              placeholder="Type here"
              formik={formik}
              name="description"
              width="w-full md:w-2/3 md:-mt-2"
            />

            <FormikSelectTwo
              label="Survey Report"
              Options={Newcontract}
              formik={formik}
              placeholder="Choose"
              name="srId"
              width="w-full md:w-1/3"
              FixPosition={true}
              PortalTarget={false}
            />

            <NuInput
              type="text"
              label="Building Name"
              placeholder="Type here"
              formik={formik}
              name="buildingName"
              width="w-full md:w-2/3"
            />

            <NuInput
              type="number"
              label="Amount"
              placeholder="Amount"
              formik={formik}
              name="amount"
              width="w-full md:w-1/3"
            />
            <FormikSelectTwo
              label="Contract Duration"
              placeholder="Choose"
              Options={[
                { value: "1 Month", label: "1 Month" },
                { value: "3 Months", label: "3 Months" },
                { value: "6 Months", label: "6 Months" },
                { value: "12 Months", label: "12 Months" },
                { value: "24 Months", label: "24 Months" },
                { value: "36 Months", label: "36 Months" },
              ]}
              formik={formik}
              name="duration"
              width="w-full md:w-1/3"
              isRequired={true}
              FixPosition={true}
              PortalTarget={false}
            />
            <NuDate
              label="Contract Start Date"
              placeholder="Contract Start Date"
              formik={formik}
              name="startDate"
              width="w-full md:w-1/3"
              isRequired={true}
            />

            <NuDate
              label="Contract End Date"
              formik={formik}
              name="endDate"
              width="w-full md:w-1/3 "
              isRequired={true}
              min={minRenewalDate || new Date().toISOString().split("T")[0]}
            />
            <NuDate
              label="Contract Renewal Date"
              formik={formik}
              name="renewalDate"
              width="w-full md:w-1/3 "
              isRequired={true}
              min={minRenewalDate || new Date().toISOString().split("T")[0]}
            />

            <NuInput
              type="number"
              label="Renewal Notice Period "
              placeholder="Renewal Notice Period"
              formik={formik}
              name="noticePeriod"
              width="w-full md:w-1/3 "
            />

            <DropDownAddMetaData
              label="Payment Terms"
              placeholder="Choose"
              Options={paymentTerms}
              formik={formik}
              name="paymentTerms"
              width="w-full md:w-1/2 lg:w-1/3 md:-mt-1"
              getFunc={refpaymentTerms}
              displayProperty={"Payment Terms"}
              propertyName={"paymentTerms"}
              FixPosition={true}
              PortalTarget={false}
            />
            <NuTextArea
              label="Notes"
              placeholder="Notes"
              formik={formik}
              name="notes"
              new_width="w-full md:w-2/3 "
              width="w-full md:w-1/2 lg:w-1/3"
            />

            <div className="w-full">
              <SettingHeading title="Attachments :" />
            </div>
            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />
          </div>

          <div className="w-full mx-auto bg-white rounded-md pb-4 mt-4">
            <div className="w-full h-full flex justify-start content-start flex-wrap mb-4">
              <div className="w-full px-4">
                <SettingHeading title="Inspection Schedule" />
              </div>
              <div className="w-full m-2 border border-solid rounded-lg">
                <div className="md:grid grid-cols-12 gap-1">
                  <div className="col-span-4 pt-2">
                   <SelectProductWithError
  type="text"
  label="Facilities / Building"
  placeholder="Facilities / Building"
  Options={equipmentOptions}   // <-- dynamic equipment list
  formik={formikAddInspection}
  name="equipmentId"
  width="w-full md:mt-[-7px]"
  ErrMessage={inspectionProductError}
  handleClick={togglePopupEqupiment}
  setSearch={setSearchequipment}
  FixPosition={true}
  PortalTarget={false}
              isRequired={true}

/>

                  </div>

                  <div className="col-span-2">
                    <DropDownAddMetaData
                      label="Location"
                      placeholder="Choose"
                      Options={location}
                      formik={formikAddInspection}
                      name="location"
                      width="w-full md:mt-[-3px]"
                      getFunc={reflocation}
                      displayProperty="Location"
                      propertyName="Inspection_Location"
                      FixPosition={true}
                      PortalTarget={false}
              isRequired={true}

                    />
                  </div>

                  <div className="col-span-2">
                    <FormikSelectTwo
                      label="Schedule"
                      placeholder="Choose"
                      Options={[
                        { value: "Monthly", label: "Monthly" },
                        { value: "Quarterly", label: "Quarterly" },
                        { value: "Half-yearly", label: "Half-yearly" },
                        { value: "Yearly", label: "Yearly" },
                      ]}
                      formik={formikAddInspection}
                      name="inspectionType"
                      width="w-full"
                      FixPosition={true}
                      PortalTarget={false}
              isRequired={true}

                    />
                  </div>

                  <div className="col-span-3">
                    <MultiSelect
                      label="Form Selection"
                      Options={form}
                      formik={formikAddInspection}
                      placeholder="Choose"
                      name="formSelection"
                      width="w-full"
                      FixPosition={true}
                      PortalTarget={false}
              isRequired={true}

                    />
                  </div>

                  <div className=" flex justify-center md:items-end mb-4">
                    <button
                      onClick={handleAddInspection}
                      type="button"
                      className="px-3 lg:px-6 h-8 bg-baseColor-primary text-white text-xs font-medium rounded-lg"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div className="w-full bg-white overflow-y-scroll mt-5">
                {inspectionError && (
                  <p className="text-xs font-semibold text-red-500 px-4">
                    {inspectionError}
                  </p>
                )}

                <div className=" w-full h-[calc(100vh-250px)] relative overflow-auto hidden md:block">
                  <div className="sticky top-0 w-full py-3 bg-baseColor-primary justify-between rounded-lg px-6 hidden md:flex text-white text-xs font-medium">
                    <div className=" w-[5%] text-left">S.No</div>
                    <div className=" w-[45%] text-left">
                      Facilities / Building
                    </div>
                    <div className=" w-[22%] text-left">Location</div>
                    <div className=" w-[23%] text-left">Schedule</div>
                    <div className=" w-[5%] text-left flex items-center gap-1 lg:gap-3">
                      <p className="">Action</p>
                      <span
                        className=" cursor-pointer"
                        onClick={() => setIsInspectionEditable((prev) => !prev)}
                      >
                        <EditIcon
                          width="12"
                          height="12"
                          color={isInspectionEditable ? "#facc15" : "#ffff"}
                        />
                      </span>
                    </div>
                  </div>
                  {items.map((List, index) => (
                    <div
                      key={index}
                      className="w-full odd:bg-white even:bg-gray-50 px-6 hidden md:block"
                    >
                      <div className="w-full py-2 flex items-center justify-between text-xs">
                        <div className=" w-[5%] text-left py-2">
                          {index + 1}
                        </div>
                        <div className="w-[45%] text-left py-2">
                          {List?.productName}
                        </div>
                        <div className=" w-[22%] text-left py-2">
                          {List?.location}
                        </div>
                        <div className=" w-[23%] text-left py-2">
                          {List?.inspectionType}
                        </div>
                        <div className="w-[5%] text-left flex items-center gap-3">
                          <button
                            onClick={() => {
                              setDeleteIndex(index);
                              setIsDeletePopupOpen(true);
                              SetRemovableItem(List?.productName);
                            }}
                            type="button"
                            disabled={!isInspectionEditable}
                            className={`${
                             isInspectionEditable
                                ? "text-red-500"
                                : "text-slate-500"
                            } cursor-pointer ml-4 border-none`}
                          >
                            <DeleteIcon
                              color={isInspectionEditable ? "red" : "grey"}
                              height={12}
                            />
                          </button>
                        </div>
                      </div>
                      <div className="w-full py-2 flex text-xs">
                        <div className=" w-[5%] py-2"></div>

                        <div className=" w-[95%] py-1  ">
                          {/* <span className="font-semibold">Form : </span> */}
                          <div className="mt-2 flex flex-wrap  gap-2">
                            {List?.formSelection &&
                            List?.formSelection.length > 0 ? (
                              List.formSelection
                                .sort((a, b) => a - b)
                                .map(
                                  (val) =>{
                                    return({label:form?.find((item) => item.value === val)?.label, sno: val})
                                  }
                                )
                                .filter(Boolean)
                                .map((item, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-start gap-2 p-1.5 bg-white border border-gray-200 rounded-md text-[10px] text-gray-700  transition"
                                  >
                                    <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-textColor-main font-semibold text-[10px]">
                                      {item?.sno}
                                    </div>
                                    <div className=" flex items-center gap-2">
                                      <p className="flex-1">{item?.label}</p>
                                      {isInspectionEditable && (
                                        <button className=" text px-1.5 py-0.5 rounded-md bg-red-400 text-white cursor-pointer"
                                         onClick={()=>deleteFormFromItem(index, idx)}
                                        >
                                         X
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                ))
                            ) : (
                              <div className="text-xs text-[#111537] mt-1">
                                -
                              </div>
                            )}
                          </div>
                        </div>
                        <div className=" w-[5%] py-2"></div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* mobile responsive  */}
                <div className="md:hidden space-y-4 mt-4 px-4">
                  {items.map((List, index) => (
                    <div
                      key={index}
                      className="p-3 border text-xs font-medium text-[#111537] rounded shadow-sm space-y-2 odd:bg-white even:bg-gray-100"
                    >
                      <div className="text-right">
                        <button
                          onClick={() => {
                            setDeleteIndex(index);
                            setIsDeletePopupOpen(true);
                            SetRemovableItem(List?.productName);
                          }}
                          type="button"
                          className="text-red-500 cursor-pointer ml-4 border-none"
                        >
                          <DeleteIcon color="red" height={12} />
                        </button>
                      </div>
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          S.No :
                        </span>{" "}
                        {index + 1}
                      </div>
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          Facilities / Building :
                        </span>{" "}
                        {List?.productName}
                      </div>
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          Location :
                        </span>{" "}
                        {List?.location}
                      </div>

                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          Schedule :
                        </span>{" "}
                        {List?.inspectionType}
                      </div>
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          Form Selection:
                        </span>{" "}
                        {List?.formSelection &&
                        List.formSelection.length > 0 ? (
                              List.formSelection
                                .sort((a, b) => a - b)
                                .map(
                                  (val) =>{
                                    return({label:form?.find((item) => item.value === val)?.label, sno: val})
                                  }
                                )
                                .filter(Boolean)
                                .map((item, idx) => (
                              <div
                                key={idx}
                                className="flex items-start mt-1 gap-2 p-1.5 bg-white border border-gray-200 rounded-md text-[10px] text-gray-700 transition"
                              >
                                <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-textColor-main font-semibold text-[10px]">
                                  {item?.sno}
                                </div>
                               <div className=" flex items-center gap-2">
                                      <p className="flex-1">{item?.label}</p>
                                      {isInspectionEditable && (
                                        <button className=" text px-1.5 py-0.5 rounded-md bg-red-400 text-white cursor-pointer"
                                         onClick={()=>deleteFormFromItem(index, idx)}
                                        >
                                         X
                                        </button>
                                      )}
                                    </div>
                              </div>
                            ))
                        ) : (
                          <div className="text-xs text-[#111537] mt-1">-</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex justify-end gap-4 mt-2 ">
                  <CancelButton handleClick={() => Oncancel(-1)} />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {isDeletePopupOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <h3 className="text-sm font-medium mb-4">Warning</h3>
            <p className="mb-6 text-xs">
              Are you sure you want to delete <b>{removableItem}</b> ?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setIsDeletePopupOpen(false)}
                className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md bg-[#E6F2F2] text-textColor-main"
              >
                No
              </button>
              <button
                onClick={() => {
                  if (deleteIndex !== null) {
                    handleDeleteItem(deleteIndex, "inspection");
                  }
                  setIsDeletePopupOpen(false);
                  setDeleteIndex(null);
                }}
                className="px-4 py-[8px] text-xs bg-textColor-main rounded-md text-white hover:opacity-90"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {showImportModal && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[85%] sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">Import</h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="mb-4">
              <NuUpload
                label="Equipment"
                width="w-full"
                accept=".xlsx, .xls"
                onChange={(e) => {
                  const file = e.target.files[0];
                  readExcel(file);
                }}
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                onClick={closeModal}
                className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm  text-textColor-main bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const fileInput =
                    document.querySelector('input[type="file"]');
                  if (fileInput.files[0]) {
                    readExcel(fileInput.files[0]);
                  } else {
                    setError("Please select a file to import.");
                  }
                }}
                className="px-4 py-2 bg-baseColor-primary text-white rounded-lg hover:bg-baseColor-primary"
              >
                Import
              </button>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-lg font-normal text-[12px]">Add Client</h2>
            <form onSubmit={handlePopupSubmit}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  type="text"
                  label="Company "
                  placeholder="Company "
                  formik={formik}
                  name="companyName"
                  width="w-full md:w-1/2 lg:w-1/2"
                  isRequired={true}
                />
                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="email"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <NuMobileNumber
                  nunCode="countryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="phone"
                  FixPosition={true}
                  PortalTarget={false}
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <DropDownAddMetaData
                  type="text"
                  label="Industry"
                  placeholder="Industry"
                  Options={industry}
                  formik={formik}
                  name="industry"
                  width="w-full md:w-1/2 lg:w-1/2"
                  displayProperty={"Industry"}
                  propertyName={"industry"}
                  getFunc={refindustry}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <FormikSelectTwo
                  Options={Rating}
                  label="Ratings"
                  placeholder="Ratings"
                  formik={formik}
                  name="ratings"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <div className="w-full">
                  <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                    Primary Contact :
                  </p>
                </div>
                <NuInput
                  type="text"
                  label="Contact Person "
                  placeholder="Contact Person "
                  formik={formik}
                  name="pcName"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <DropDownAddMetaData
                  type="text"
                  label="Designation"
                  placeholder="Designation"
                  Options={designation}
                  formik={formik}
                  name="pcDesignation"
                  width="w-full md:w-1/2 lg:w-1/2 md:-mt-1"
                  displayProperty={"Designation"}
                  propertyName={"Designation_Client"}
                  getFunc={refdesignation}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <NuMobileNumber
                  nunCode="pcCountryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="pcMobile"
                  width="w-full md:w-1/2 lg:w-1/2"
                  FixPosition={true}
                  PortalTarget={false}
                />
                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="pcEmail"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopup}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                                <SubmitButton isLoading={isLoading} />
                
                {/* <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button> */}
              </div>
            </form>
          </div>
        </div>
      )}

      {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[85%] sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">
                Export Data
              </h2>

              <button
                onClick={closeFilterDialogebox}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <p className=" text-sm">
                Are you sure to export all data from the table?{" "}
              </p>
              <div className="flex justify-end gap-3 mt-4">
                <button
                  type="button"
                  onClick={closeFilterDialogebox}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-baseColor-primary text-white rounded-lg hover:bg-baseColor-primary"
                >
                  Export
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showPopupEquipment && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">Add Facilities / Building</h2>
            <form onSubmit={handlePopupSubmitEquipmt}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  label="Name"
                  placeholder="Name"
                  formik={formik}
                  name="name"
                  width="w-full"
                  new_width="w-full"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopupEqupiment}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                        rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                                <SubmitButton isLoading={isLoading} />
                
                {/* <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button> */}
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreateContractsTest;
